import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../../config/authAxios"
import apiRoutes from "../../apiConfigs"

export const courseSubSectionDeleteApi = createAsyncThunk(
    'courses/sub-section-delete',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.delete(apiRoutes.courseSubSecAction(`${data.course_id}`,0),
                {
                    params: {
                        sub_section_block_id: data.subsection_block_id,
                    }
                })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const courseSubSectionDeleteSlice = createSlice({
    name: 'sub-section-delete',
    initialState: intialState,
    reducers: {
        reset: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(courseSubSectionDeleteApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(courseSubSectionDeleteApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(courseSubSectionDeleteApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { reset } = courseSubSectionDeleteSlice.actions;
export const courseSubSectionDeleteReducer = courseSubSectionDeleteSlice.reducer